import Link from 'next/link'
import React from 'react'
import { AIRCON_GUIDE_CLUSTERS, guideHref } from '../../../../utils/aircon-guide-clusters'

/**
 * The hub's link into the aircon guides: one pillar guide per topic cluster
 * (utils/aircon-guide-clusters.js), plus the full listing. The hub used to link
 * no guide at all, so the guides' topical relevance never flowed back to the
 * page that ranks for "aircon servicing singapore".
 */
export const AirconGuides = () => (
    <section className="py-12 px-4 bg-white" aria-labelledby="aircon-guides">
        <div className="max-w-5xl mx-auto">
            <h2 id="aircon-guides" className="text-2xl md:text-3xl font-extrabold text-gray-900 tracking-tight text-center">
                Aircon Guides for Singapore Homes
            </h2>
            <p className="text-gray-600 text-center mt-3 max-w-2xl mx-auto text-sm md:text-base">
                Practical guides from the StringsSG aircon team, grouped by the problem you are trying to solve.
            </p>
            <ul className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-8">
                {AIRCON_GUIDE_CLUSTERS.map((cluster) => (
                    <li key={cluster.key} className="rounded-xl border border-gray-200 p-5 space-y-2">
                        <h3 className="font-semibold text-gray-900">{cluster.title}</h3>
                        <p className="text-sm text-gray-600">{cluster.blurb}</p>
                        <Link href={guideHref(cluster.pillar.slug)} prefetch={false} className="inline-block text-sm text-orange-600 hover:underline">
                            {cluster.pillar.title}
                        </Link>
                    </li>
                ))}
            </ul>
            <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 mt-8 text-sm">
                <Link href={guideHref('singapore-aircon-servicing-report')} prefetch={false} className="text-orange-600 font-semibold hover:underline">
                    Singapore Aircon Servicing Report 2026
                </Link>
                <Link href="/sg/blogs/hvac-services" prefetch={false} className="text-orange-600 font-semibold hover:underline">
                    Browse all aircon guides
                </Link>
                <Link href="/sg/aircon-servicing-singapore/how-stringssg-works" prefetch={false} className="text-orange-600 hover:underline">
                    How StringsSG aircon servicing works
                </Link>
            </div>
        </div>
    </section>
)
